// ToastProvider.jsx - Updated
import React, { createContext, useContext, useState, useCallback } from "react";
import { Snackbar } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { toastActions } from "../store/slices/toastSlice";
import { LsAlert } from "../core"; // Import your styled alert

export const ToastContext = createContext(null);

export const ToastProvider = ({ children }) => {
  const dispatch = useDispatch();
  const reduxToast = useSelector(state => state.toast?.toast);
  const [contextToast, setContextToast] = useState({ 
    open: false, 
    message: '', 
    severity: 'info' 
  });

  const showToast = useCallback((message, severity = 'info') => {
    // Store in context
    setContextToast({ open: true, message, severity });
    
    // Also dispatch to Redux
    dispatch(toastActions.showToast({ message, severity }));
  }, [dispatch]);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setContextToast(prev => ({ ...prev, open: false }));
    dispatch(toastActions.hideToast());
  };

  // Determine which toast to show
  const toastToShow = reduxToast?.open ? reduxToast : contextToast;

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <Snackbar 
        open={toastToShow.open} 
        autoHideDuration={3000} 
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <LsAlert 
          onClose={handleClose} 
          severity={toastToShow.severity} 
          sx={{ width: '100%', minWidth: '300px' }}
        >
          {toastToShow.message}
        </LsAlert>
      </Snackbar>
    </ToastContext.Provider>
  );
};